import {
  Container,
  Form,
  Row,
  Col,
  Button,
  ToggleButtonGroup,
  ToggleButton,
  Tab,
  Nav,
} from "react-bootstrap";
import React, { useEffect, useState } from "react";
import {
  BASIC_CONFIG_DATA,
  GET_BASIC_SETTING,
  UPDATE_BASIC_SETTING,
} from "../../../../services/ApiCalls";
import { toast } from "react-toastify";

import Loader from "../../../../components/Common/Loader";

function BasicSettings() {
  const [activeTab, setActiveTab] = useState("googleMaps");
  const [configData, setConfigData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    country: "",
    address: "",
    timezone: "",
    sessionPaymentType: "",
    subscriptionDiscount: 0,
    subscriptionPopAfterDay:0,
    subscriptionPopAfterDay:0,
    questionToggle:false,
    currency: "",
    language: "",
    orderAutoApproval: "YES",
    orderAutoCancel: "YES",
    googleMapKey: {
      android: "**ddfd",
      ios: "dfds",
      web: "**********************",
      server: "**********************",
    },
    categoryPrices: {
      audioCallPrice: 0,
      audioCallTime: 0,
      videoCallPrice: 0,
      videoCallTime: 0,
    },
    mailgun: {
      MAILGUN_API_KEY: "**********************",
      MAILGUN_DOMAIN: "***********reations.com",
      MAILGUN_FROM: "*******************eatic",
    },
    twilio: {
      accountSid: "**ddfd",
      authToken: "dfds",
      twilioFrom: "**********************",
    },
    firebase: {
      FCM_APIKEY: "",
      FCM_APPID: "",
      FCM_AUTHDOMAIN: "",
      FCM_CLIENT_EMAIL: "",
      FCM_DATABASEURL: "",
      FCM_MEASUREMENTID: "",
      FCM_MESSAGINGSENDERID: "",
      FCM_PRIVATE_KEY: "",
      FCM_PROJECTID: "",
      FCM_STORAGEBUCKET: "",
    },
    versionSetting: {
      androidUser: { forceUpdateStatus: false, forceVersion: 1 },
      iosUser: { forceUpdateStatus: false, forceVersion: 1 },
    },
    serviceCommission: 20,
  });

  useEffect(() => {
    getConfigData();
    getBasicSetting();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let selectedItem;
    try {
      selectedItem = JSON.parse(value);
    } catch (err) {
      selectedItem = value;
    }

    console.log(name, selectedItem); // Log the name and the selected object

    setFormData((prevData) => ({
      ...prevData,
      [name]: selectedItem, // Store the entire object in the formData
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    const keys = name.split(".");

    setFormData((prevData) => {
      const updatedData = { ...prevData };
      let current = updatedData;

      for (let i = 0; i < keys.length - 1; i++) {
        const key = keys[i];
        if (!current[key]) current[key] = {};
        current = current[key];
      }

      current[keys[keys.length - 1]] = value;

      return updatedData;
    });
  };

  const handleToggleChange = (name, value) => {
    console.log(name, value); // This will log the name of the field and the selected value
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };
  const handleVersionChange = (e) => {
    const { name, value } = e.target;
    const [platform, field] = name.split("."); // Split name to identify platform and field

    setFormData((prevData) => ({
      ...prevData,
      versionSetting: {
        ...prevData.versionSetting,
        [platform]: {
          ...prevData.versionSetting[platform],
          [field]: value, // Update the specific field (forceUpdateStatus or forceVersion) for the platform (androidUser or iosUser)
        },
      },
    }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    // handle form submission (e.g., save settings)
    try {
      const res = await UPDATE_BASIC_SETTING(formData);

      if (res && res.data.status == "success") {
        toast.success(res?.data?.message);
        getBasicSetting();
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error(res?.data?.message);
    }
  };

  const getConfigData = async () => {
    try {
      const res = await BASIC_CONFIG_DATA();
      console.log(res);
      if (res && res.data.status == "success") {
        setConfigData(res?.data?.data);
      } else {
        setConfigData(null);
      }
    } catch (error) {
      setConfigData(null);
    }
  };

  const getBasicSetting = async () => {
    setLoading(true);
    try {
      const res = await GET_BASIC_SETTING();

      if (res && res.data.status == "success") {
        setLoading(false);
        const { data } = res.data;
        console.log(data);
        setFormData({
          country: data?.country || "",
          subscriptionPopAfterDay: data?.subscriptionPopAfterDay,
          address: data?.address || "",
          timezone: data?.timezone || "",
          currency: data?.currency || "",
          questionToggle:data?.questionToggle || false,
          language: "English",
          orderAutoApproval: "YES",
          orderAutoCancel: "YES",
          googleMapKey: data?.googleMapKey,
          mailgun: data?.mailgun,
          twilio: data?.twilio,
          firebase: data?.firebase,
          versionSetting: data?.versionSetting,
          // serviceCommission: data?.serviceCommission,
          categoryPrices: data?.categoryPrices,
          subscriptionDiscount: data?.subscriptionDiscount,
          sessionPaymentType: data?.sessionPaymentType,
        });
      } else {
        setLoading(false);
      }
    } catch (error) {}
  };

  return (
    <>
      {" "}
      {loading && <Loader />}
      <Container className="my-5 ">
        <h4 className="pt-4">Basic Settings</h4>
        <p className="text-muted">
          To Set the global parameters based on your nature of business and
          Country Region for your Online Business.
        </p>

        <Form onSubmit={handleSubmit}>
          <Row className="mb-3">
            <Col md={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  Country
                </Form.Label>
                <Col sm={8}>
                  <Form.Select
                    defaultValue={formData.country}
                    name="country"
                    onChange={handleChange}
                  >
                    {configData &&
                      configData?.countries?.map((item) => {
                        return <option value={item?.code}>{item?.name}</option>;
                      })}
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  Address
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    type="text"
                    value={formData?.address}
                    name="address"
                    onChange={handleInputChange}
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  Time Zone
                </Form.Label>
                <Col sm={8}>
                  <Form.Select
                    value={formData?.timezone}
                    name="timezone"
                    onChange={handleChange}
                  >
                    {configData &&
                      configData?.timezones?.map((item) => {
                        return <option value={item?.code}>{item?.name}</option>;
                      })}
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  Currency
                </Form.Label>
                <Col sm={8}>
                  <Form.Select
                   value={JSON.stringify(formData.currency)}
                    defaultValue={JSON.stringify(formData.currency)} // Set the initial value as a stringified object
                    name="currency"
                    onChange={handleChange}
                  >
                    {configData &&
                      configData?.currencies?.map((item) => {
                        return (
                          <option
                            key={item?.code}
                            value={JSON.stringify({
                              code: item?.code,
                              name: item?.name,
                            })}
                          >
                            {item?.name}-{item?.code}
                          </option>
                        );
                      })}
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  Language
                </Form.Label>
                <Col sm={8}>
                  <Form.Select
                    defaultValue={JSON.stringify(formData.language)} // Set the initial value as a stringified object
                    name="language"
                    onChange={handleChange}
                  >
                    {configData &&
                      configData?.languages?.map((item) => {
                        return (
                          <option
                            key={item?.code}
                            value={JSON.stringify({
                              code: item?.code,
                              name: item?.name,
                            })}
                          >
                            {item?.name}
                          </option>
                        );
                      })}
                  </Form.Select>
                </Col>
              </Form.Group>
            </Col>
          </Row>
          {/* <Row className="mb-3">
            <Col md={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  Subscription Commission (%)
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    type="number"
                    name="serviceCommission"
                    placeholder="0"
                    value={formData?.serviceCommission}
                    onChange={handleInputChange}
                    min="0"
                  />
                </Col>
              </Form.Group>
            </Col>
          </Row> */}

          <Row className="mb-3">
            <Col md={6}>
              <Form.Group className="basic-setting-wrapper" as={Row}>
                <Form.Label column sm={4}>
                  Referral Discount Setting{" "}
                </Form.Label>
                <Col sm={8}>
                  <ToggleButtonGroup
                    type="radio"
                    name="orderAutoApproval"
                    value={formData.orderAutoApproval}
                    onChange={(value) => {
                      handleToggleChange("orderAutoApproval", value);
                      // Auto-set discount to 20 when YES is selected
                      if (value === "YES") {
                        handleInputChange({
                          target: { name: "serviceCommission", value: 20 },
                        });
                      } else {
                        handleInputChange({
                          target: { name: "serviceCommission", value: 0 },
                        });
                      }
                    }}
                  >
                    <ToggleButton id="acceptYes" value="YES">
                      YES
                    </ToggleButton>
                    <ToggleButton id="acceptNo" value="NO">
                      NO
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Col>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  Discount (%)
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                    type="number"
                    name="serviceCommission"
                    placeholder="0"
                    value={formData?.serviceCommission}
                    onChange={handleInputChange}
                    min="0"
                  />
                </Col>
              </Form.Group>
            </Col>
            <Row className="mb-3">
            <Col md={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                 Audio Call Price
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                  onWheel={(e) => e.currentTarget.blur()}
                    type="number"
                    name="categoryPrices.audioCallPrice"
                    placeholder="0"
                    value={formData?.categoryPrices?.audioCallPrice}
                    onChange={handleInputChange}
                    min="0"
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                 Session Duration(minutes)
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                  onWheel={(e) => e.currentTarget.blur()}
                    type="number"
                    name="categoryPrices.sessionSlotTime"
                    placeholder="0"
                    value={formData?.categoryPrices?.sessionSlotTime}
                    onChange={handleInputChange}
                    min="0"
                  />
                </Col>
              </Form.Group>
            </Col>
            </Row>
            <Row className="mb-3">
            <Col md={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                 Video Call Price
                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                  onWheel={(e) => e.currentTarget.blur()}
                    type="number"
                    name="categoryPrices.videoCallPrice"
                    placeholder="0"
                    value={formData?.categoryPrices?.videoCallPrice}
                    onChange={handleInputChange}
                    min="0"
                  />
                </Col>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                 Session Type
                </Form.Label>
                <Col sm={8}>
                    <Form.Select
                    
                    name="sessionPaymentType"
                    value={formData?.sessionPaymentType}
                    onChange={handleInputChange}
                    >
                        <option value="free">Free</option>
                        {/* <option value="paid">Paid</option> */}
                        <option value="subscription">Subscription</option>
                        <option value="one_time_payment">One Time Payment</option>
                        <option value="both">Both</option>
                    </Form.Select>
                  
                </Col>
              </Form.Group>
            </Col>
            </Row>
             <Row className="mb-3">
            <Col md={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
Subscription Discount(%)                </Form.Label>
                <Col sm={8}>
                  <Form.Control
                  onWheel={(e) => e.currentTarget.blur()}
                    type="number"
                    name="categoryPrices.subscriptionDiscount"
                    placeholder="0"
                    value={formData?.subscriptionDiscount}
                    onChange={handleInputChange}
                    min="0"
                    max="100"
                  />
                </Col>
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
Subscription popup After Day               </Form.Label>
                <Col sm={8}>
                  <Form.Control
                  onWheel={(e) => e.currentTarget.blur()}
                    type="number"
                    name="subscriptionPopAfterDay"
                    placeholder="0"
                    value={formData?.subscriptionPopAfterDay}
                    onChange={handleInputChange}
                    min="0"
                  />
                </Col>
              </Form.Group>
            </Col>
            </Row>
          </Row>


           <Row className="mb-3">
            <Col md={6}>
              <Form.Group className="basic-setting-wrapper" as={Row}>
                <Form.Label column sm={4}>
                  Questions{" "}
                </Form.Label>
                <Col sm={8}>
                  <ToggleButtonGroup
                    type="radio"
                    name="questionToggle"
                    value={formData.questionToggle}
                    onChange={(value) => {
                      handleToggleChange("questionToggle", value);
                     
                    }}
                  >
                    <ToggleButton id="acceptYess" value={true}>
                      YES
                    </ToggleButton>
                    <ToggleButton id="acceptNoo" value={false}>
                      NO
                    </ToggleButton>
                  </ToggleButtonGroup>
                </Col>
              </Form.Group>
            </Col>
            </Row>

          

          <h4>API Keys</h4>
          <p className="text-muted">
            Keys are encrypted alphanumeric values to access services in your
            mobile apps.
          </p>

          <div className="basic-setting-tabs-wrapper">
            <Tab.Container
              activeKey={activeTab}
              onSelect={(tab) => setActiveTab(tab)}
            >
              <Nav variant="tabs" className="mb-3">
                <Nav.Item>
                  <Nav.Link eventKey="googleMaps">Google Maps</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="mailgun">Mailgun</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="twilio">Twilio</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="firebase">Firebase</Nav.Link>
                </Nav.Item>
              </Nav>

              <Tab.Content>
                <Tab.Pane eventKey="googleMaps">
                  <h5>Google Maps Keys</h5>
                  <Row>
                    <Col md={3}>
                      <p>
                        <strong>Android Google Maps Key</strong>: This will be
                        generated using Google Developer Account
                      </p>
                      <p>
                        <strong>IOS Google Maps Key</strong>: This will be
                        generated using App Store/Apple Developer Account
                      </p>
                      <p>
                        <strong>Web Google Maps Key</strong>: This will be
                        generated using Google Developer Account
                      </p>
                      <p>
                        <strong>Server Google Maps Key</strong>: This will be
                        generated using Google Developer Account
                      </p>
                    </Col>
                    <Col md={9}>
                      <Form>
                        <Form.Group as={Row} className="mb-3">
                          <Form.Label sm={5}>
                            Android Google Maps Key
                          </Form.Label>
                          <Col sm={7}>
                            <Form.Control
                              type="text"
                              placeholder="**ddfd"
                              value={formData.googleMapKey.android}
                              onChange={handleInputChange}
                              name="googleMapKey.android"
                            />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                          <Form.Label sm={5}>IOS Google Maps Key</Form.Label>
                          <Col sm={7}>
                            <Form.Control
                              type="text"
                              placeholder="dfds"
                              value={formData.googleMapKey.ios}
                              onChange={handleInputChange}
                              name="googleMapKey.ios"
                            />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                          <Form.Label sm={5}>Web Google Maps Key</Form.Label>
                          <Col sm={7}>
                            <Form.Control
                              type="text"
                              placeholder="**********************"
                              value={formData.googleMapKey.web}
                              onChange={handleInputChange}
                              name="googleMapKey.web"
                            />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                          <Form.Label sm={5}>Server Google Maps Key</Form.Label>
                          <Col sm={7}>
                            <Form.Control
                              type="text"
                              placeholder="**********************"
                              value={formData.googleMapKey.server}
                              onChange={handleInputChange}
                              name="googleMapKey.server"
                            />
                          </Col>
                        </Form.Group>
                      </Form>
                    </Col>
                  </Row>
                </Tab.Pane>

                {/* Additional tabs can be implemented similarly */}
                <Tab.Pane eventKey="mailgun">
                  <h5>Mailgun Keys</h5>
                  <Row>
                    <Col md={3}>
                      <p>
                        <strong>Mailgun API Key</strong>: Your Mailgun API key
                        for sending emails
                      </p>
                      <p>
                        <strong>Mailgun Domain</strong>: The Mailgun used with
                        your Mailgun account
                      </p>
                      <p>
                        <strong>Mailgun From</strong>: The sender email for
                        Mailgun emails
                      </p>
                    </Col>
                    <Col md={9}>
                      <Form>
                        <Form.Group as={Row} className="mb-2">
                          <Form.Label sm={5}>Mailgun API Key</Form.Label>
                          <Col sm={7}>
                            <Form.Control
                              type="text"
                              placeholder="**********************"
                              value={formData.mailgun.MAILGUN_API_KEY}
                              onChange={handleInputChange}
                              name="mailgun.MAILGUN_API_KEY"
                            />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-2">
                          <Form.Label sm={5}>Mailgun Domain</Form.Label>
                          <Col sm={7}>
                            <Form.Control
                              type="text"
                              placeholder="***********reations.com"
                              value={formData.mailgun.MAILGUN_DOMAIN}
                              onChange={handleInputChange}
                              name="mailgun.MAILGUN_DOMAIN"
                            />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-2">
                          <Form.Label sm={5}>Mailgun From</Form.Label>
                          <Col sm={7}>
                            <Form.Control
                              type="text"
                              placeholder="*******************eatic"
                              value={formData.mailgun.MAILGUN_FROM}
                              onChange={handleInputChange}
                              name="mailgun.MAILGUN_FROM"
                            />
                          </Col>
                        </Form.Group>
                      </Form>
                    </Col>
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="twilio">
                  <h5>Twilio Settings</h5>
                  <Row>
                    <Col md={3}>
                      <p>
                        Keys is a encrypted alphanumeric value to access the
                        google map services in your mobile Apps
                      </p>
                    </Col>
                    <Col md={9}>
                      <Form>
                        <Form.Group as={Row} className="mb-3">
                          <Form.Label sm={5}>Account Sid</Form.Label>
                          <Col sm={7}>
                            <Form.Control
                              type="text"
                              placeholder="**ddfd"
                              value={formData.twilio.accountSid}
                              onChange={handleInputChange}
                              name="twilio.accountSid"
                            />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                          <Form.Label sm={5}>Auth Token</Form.Label>
                          <Col sm={7}>
                            <Form.Control
                              type="text"
                              placeholder="dfds"
                              value={formData.twilio.authToken}
                              onChange={handleInputChange}
                              name="twilio.authToken"
                            />
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row} className="mb-3">
                          <Form.Label sm={5}>Twilio From</Form.Label>
                          <Col sm={7}>
                            <Form.Control
                              type="text"
                              placeholder="**********************"
                              value={formData.twilio.twilioFrom}
                              onChange={handleInputChange}
                              name="twilio.twilioFrom"
                            />
                          </Col>
                        </Form.Group>
                      </Form>
                    </Col>
                  </Row>
                </Tab.Pane>
                <Tab.Pane eventKey="firebase">
                  <h5>Firebase Settings</h5>
                  <Row>
                    <Col md={3}>
                      <p>
                        Keys is a encrypted alphanumeric value to access the
                        google map services in your mobile Apps
                      </p>
                    </Col>
                    <Col md={9}>
                      <Form>
                        <Row className="mb-3">
                          <Col sm={6}>
                            <Form.Label>API Key</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="**ddfd"
                              value={formData.firebase.FCM_APIKEY}
                              onChange={handleInputChange}
                              name="firebase.FCM_APIKEY"
                            />
                          </Col>
                          <Col sm={6}>
                            <Form.Label>Auth Domain</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="dfds"
                              value={formData.firebase.FCM_AUTHDOMAIN}
                              onChange={handleInputChange}
                              name="firebase.FCM_AUTHDOMAIN"
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm={6}>
                            <Form.Label>Project Id</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="**********************"
                              value={formData.firebase.FCM_PROJECTID}
                              onChange={handleInputChange}
                              name="firebase.FCM_PROJECTID"
                            />
                          </Col>
                          <Col sm={6}>
                            <Form.Label>Storage Bucket</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="**********************"
                              value={formData.firebase.FCM_STORAGEBUCKET}
                              onChange={handleInputChange}
                              name="firebase.FCM_STORAGEBUCKET"
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm={6}>
                            <Form.Label>Messaging Sender Id</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="**********************"
                              value={formData.firebase.FCM_MESSAGINGSENDERID}
                              onChange={handleInputChange}
                              name="firebase.FCM_MESSAGINGSENDERID"
                            />
                          </Col>
                          <Col sm={6}>
                            <Form.Label>App Id</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="**********************"
                              value={formData.firebase.FCM_APPID}
                              onChange={handleInputChange}
                              name="firebase.FCM_APPID"
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm={6}>
                            <Form.Label>Measurement Id</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="**********************"
                              value={formData.firebase.FCM_MEASUREMENTID}
                              onChange={handleInputChange}
                              name="firebase.FCM_MEASUREMENTID"
                            />
                          </Col>
                          <Col sm={6}>
                            <Form.Label>Client Email</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="**********************"
                              value={formData.firebase.FCM_CLIENT_EMAIL}
                              onChange={handleInputChange}
                              name="firebase.FCM_CLIENT_EMAIL"
                            />
                          </Col>
                        </Row>

                        <Row className="mb-3">
                          <Col sm={6}>
                            <Form.Label>Private Key</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="**********************"
                              value={formData.firebase.FCM_PRIVATE_KEY}
                              onChange={handleInputChange}
                              name="firebase.FCM_PRIVATE_KEY"
                            />
                          </Col>
                        </Row>
                      </Form>
                    </Col>
                  </Row>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </div>
          <h4>Version Settings</h4>
          <p className="text-muted">
            Configure version settings for Android and iOS User Apps to control
            force updates.
          </p>
          <Form>
            {/* Android User App Settings */}
            <h5>Android User App</h5>
            <Row className="mb-3">
              <Form.Group as={Col} md={6}>
                <Form.Label>Force Update Status</Form.Label>
                <Form.Control
                  as="select"
                  name="androidUser.forceUpdateStatus"
                  value={formData.versionSetting?.androidUser.forceUpdateStatus}
                  onChange={handleVersionChange}
                >
                  <option value={true}>Enabled</option>
                  <option value={false}>Disabled</option>
                </Form.Control>
              </Form.Group>
              <Form.Group as={Col} md={6}>
                <Form.Label>Force Version</Form.Label>
                <Form.Control
                  type="text"
                  name="androidUser.forceVersion"
                  value={formData.versionSetting?.androidUser.forceVersion}
                  onChange={handleVersionChange}
                />
              </Form.Group>
            </Row>

            {/* iOS User App Settings */}
            <h5>iOS User App</h5>
            <Row className="mb-3">
              <Form.Group as={Col} md={6}>
                <Form.Label>Force Update Status</Form.Label>
                <Form.Control
                  as="select"
                  name="iosUser.forceUpdateStatus"
                  value={formData.versionSetting?.iosUser.forceUpdateStatus}
                  onChange={handleVersionChange}
                >
                  <option value={true}>Enabled</option>
                  <option value={false}>Disabled</option>
                </Form.Control>
              </Form.Group>
              <Form.Group as={Col} md={6}>
                <Form.Label>Force Version</Form.Label>
                <Form.Control
                  type="text"
                  name="iosUser.forceVersion"
                  value={formData.versionSetting?.iosUser.forceVersion}
                  onChange={handleVersionChange}
                />
              </Form.Group>
            </Row>
          </Form>
          <div className="text-center">
            <Button variant="primary" type="submit">
              Save Settings
            </Button>
          </div>
        </Form>
      </Container>
    </>
  );
}

export default BasicSettings;
